import * as FormConst from 'constants/FormConst'
import RouteConst from 'constants/RouteConst'
import URLConst from 'constants/URLConst'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { clearSession } from 'utilities/SessionHelper'
import FormModal from '../../organisms/FormModal/FormModal'

/**
 * Error Modal to be displayed for all forms. Handles lock and auth errors.
 * isAuthError - boolean property to be used to use this handler for auth errors.
 * isLockError - boolean property to be used to use this handler for lock errors.
 */
class ErrorHandler extends Component {

    /**
     * Returns the modal text based on the type of error
     * @returns {string} the modal text
     */
    getModalText = () => {
        if (this.props.isAuthError) {
            return FormConst.MODAL_UPDATE_ACTION_AUTH_ERROR_TEXT
        } else if (this.props.isLockError) {
            return FormConst.MODAL_UPDATE_ACTION_LOCK_ERROR_TEXT
        }
        return FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE
    }

    /**
     * Returns the modal title based on the type of error
     * @returns {string} the modal title
     */
    getModalTitle = () => {
        if (this.props.isAuthError) {
            return FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE
        } else if (this.props.isLockError) {
            return FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE
        }
        return FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE
    }

    /**
     * Lifecycle method that runs when the component is updated. Handles auth error.
     * 
     */
    componentDidUpdate() {
        // Redirect to okta logout path on auth error
        if (this.props.isAuthError) {
            clearSession()
            window.location.href = URLConst.OKTA_SERVICE + URLConst.PATH_OKTA_LOGOUT_REDIRECT
            return null
        }
    }

    render() {
        return (
            <FormModal
                id='error-handler-lock-error-modal'
                hotelInfo={this.props.hotelInfo}
                title={this.getModalTitle()}
                body={<h5>{this.getModalText()}</h5>}
                isError
                proceed={() => {
                    this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
                }}
                proceedName='Home Page'
                show={this.props.isAuthError || (this.props.showLockError && this.props.isLockError)} />
        )
    }
}

// Map redux state to props
const mapStateToProps = state => {
    return {
        isLockError: state.reducer.isLockError,
        isAuthError: state.reducer.isAuthError
    }
}

export default connect(mapStateToProps)(withRouter(ErrorHandler))